export default __webpack_public_path__ + "8241c3dec31e49fb167833088868ba00.png";